export * from './busca-extrato-cobranca.component';
